module.exports = __webpack_public_path__ + "img/logo.1142e9e1.svg";